import Api from '@/api/api.js'
import config_api from '@/api/config/_api_config'

// La capacité est fournie par l'écran et n'est jamais stockée dans Vuex/localStorage.
const options = token => ({ timeout: 20000, med_access_scoped: true, headers: { 'X-Kine-Config': token } })
export default {
    getSpecialties(token) { return Api().get('/kine/configuration/specialites', options(token)).then(response => response.data) },
    setSpecialty(id, enabled, token) { return Api().post(`/kine/configuration/specialites/${id}`, { suivi_par_seances: enabled }, options(token)).then(response => response.data) },
    getAccess() {
        return config_api().post('/parametres/kine-access', {}, { timeout: 20000, kine_config_scoped: true }).then(response => response.data)
    },
    getFiches(typeId, token) {
        return Api().get('/kine/configuration/fiches', Object.assign(options(token), { params: { type_consultation_id: typeId } })).then(response => response.data)
    },
    getVersions(ficheId, token) {
        return Api().get(`/kine/fiches/${ficheId}/versions`, options(token)).then(response => response.data)
    },
    publishVersion(ficheId, data, token, key) {
        const config = options(token)
        config.headers['Idempotency-Key'] = key
        const body = { expected_revision: data.expected_revision, mode: data.mode, sections: data.sections.map(section => ({
            section_id: section.section_id, scope: section.scope, required_fields: section.required_fields.slice()
        })) }
        return Api().post(`/kine/fiches/${ficheId}/versions`, body, config).then(response => response.data)
    }
}
